import React from "react";
import NavBar from "../../components/navBar/NavBar";
import axios from "axios";
import "../../assets/style/style.css";
import swal from "sweetalert";

import ptBr from "moment/locale/pt-br";
import moment from "moment";
import MaskedInput from "react-text-mask";

import Submit from "../../components/submit/Submit";

import "react-dates/initialize";
import {
  //DateRangePicker,
  SingleDatePicker
  //DayPickerRangeController
} from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import io from "socket.io-client";
require("dotenv").config();
const url = process.env.REACT_APP_API_TASK;
const urlSocket = process.env.REACT_APP_API_SOCKET;
const socket = io(urlSocket);
class ActivityAll extends React.Component {
  constructor(props) {
    super(props);
    // this.HandleClickRadioService = this.handleClickRadioService.bind(this);

    this.state = {
      id_pop: "",
      pop: "",
      endereco: "",
      complemento: "",
      bairro: "",
      telefone: "",
      data_chegada: "",
      hora_chegada: "",
      hora_liberacao: "",
      hora_saida: "",
      descricao: "",
      tipo_servico: "",
      observacao: "",
      pendencia: "",
      diagnostico: "",
      diagnostico_outro: "",
      solucao: "",
      solucao_outro: "",
      img: [],
      imgText: [],
      load: false
    };
  }

  componentWillMount() {
    moment.locale("pt-br", ptBr);
  }

  componentDidMount() {
    const objForm = {
      id: this.props.match.params.id,
      token: localStorage.getItem("token")
    };
    this.getActivityAll(objForm);
  }

  startTask = () => {
    console.log("starta");
    const token = localStorage.getItem("token");
    const objForm = { id_rat_pop: this.props.match.params.id, token: token };

    axios
      .post(
        `${url}/inicioTask`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        socket.emit("newTask", "postDash");
        this.setState({
          status: "andamento"
        });
      });
  };

  pauseTask = () => {
    console.log("pausar");
    const token = localStorage.getItem("token");
    const objForm = { id_rat_pop: this.props.match.params.id, token: token };
    axios
      .post(
        `${url}/pauseTask`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        socket.emit("newTask", "postDash");
        this.setState({
          status: "pause"
        });
      });
  };

  getActivityAll = objForm => {
    axios
      .post(
        `${url}/atividade_pop`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        if (response.data.rat_pop["0"].data_chegada) {
          this.setState({
            date: moment(response.data.rat_pop["0"].data_chegada)
          });
        }
        this.setState({
          hora_chegada: response.data.rat_pop["0"].hora_chegada,
          hora_liberacao: response.data.rat_pop["0"].hora_liberacao,
          hora_saida: response.data.rat_pop["0"].hora_saida,
          descricao: response.data.rat_pop["0"].descricao,
          observacao: response.data.rat_pop["0"].observacao,
          atividade: response.data.rat_pop["0"].atividade,

          status: response.data.rat_pop["0"].status,
          tecnico: response.data.rat_pop["0"].tecnico
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  handleClickRadioService(event) {
    this.setState({ tarefaConcluida: event.target.value });
  }

  postForm = () => {
    this.setState({ load: true });
    const objForm = {
      token: localStorage.getItem("token"),
      id: this.props.match.params.id,
      tecnico: this.state.tecnico,
      data_chegada: moment(this.state.date).format("YYYY-MM-DD"),
      hora_chegada: this.state.hora_chegada,
      hora_liberacao: this.state.hora_liberacao,
      hora_saida: this.state.hora_saida,
      observacao: this.state.observacao
    };
    if (socket.connected) {
      axios
        .post(
          url + "/rat_all",
          {
            objForm: objForm
            //nome : 'bruno'
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8"
            }
          }
        )
        .then(response => {
          //console.log(response.data);
          this.setState({ load: false });
          socket.emit("newTask", "postDash");
          if (response.data === 1) {
            swal({
              title: "Salvo",
              text: "Dados enviados!",
              icon: "success"
            }).then(willDelete => {
              if (willDelete) {
                window.location.reload();
              }
            });
          } else {
            swal("Não Salvo", " Ocorreu erro ao Salvar ", "error");
            //this.setState({load:false});
          }
        })
        .catch(function(error) {
          console.log(error);
          swal("Não Salvo", " Ocorreu erro ao Salvar ", "error");
        });
    } else {
      let arrayLocal = [];
      if (localStorage.getItem("dadosPop")) {
        arrayLocal = JSON.parse(localStorage.getItem("dadosPop"));
        arrayLocal.push(objForm);
      } else {
        arrayLocal.push(objForm);
      }
      arrayLocal = JSON.stringify(arrayLocal);
      localStorage.setItem("dadosPop", arrayLocal);
      swal({
        title: "Salvo",
        text: "Dados Salvos no aparelho, sem conectividade com a internet!",
        icon: "success"
      }).then(willDelete => {
        if (willDelete) {
          window.location.reload();
        }
      });
      this.setState({ load: false });
    }
  };

  handleInputChange = e => {
    //console.log(e);
    const key = e.target.name;

    this.setState({ observacao: e.target.value });
    this.setState({ [key]: e.target.value });
  };

  handleInputChangeHora = e => {
    const key = e.target.id;
    this.setState({ [key]: e.target.value });
  };

  render() {
    return (
      <React.Fragment>
        <NavBar wayLast={`/task-descriptions/${this.props.match.params.id}`} />
        <div className="container-fluid container_body">
          <div className="containerCard">
            {this.state.status === "concluido" && (
              <React.Fragment>
                <center>
                  <div>
                    <div className="d-flex justify-content-center">
                      <div className="p-2 bd-highlight align-self-center">
                        <i
                          className="fas fa-check-circle fa-2x"
                          style={{ color: "green" }}
                        ></i>
                      </div>
                      <div className="p-2 bd-highlight align-self-center">
                        <b> Rat Concluída</b>
                      </div>
                    </div>
                  </div>
                </center>
              </React.Fragment>
            )}

            <div className="card marginTop6">
              <h5 className="card-header">Data</h5>
              <div className="card-body">
                <div className="form-group">
                  <p>
                    Data da Chegada
                    {!this.state.date && (
                      <span className="text-danger"> * </span>
                    )}
                  </p>

                  <SingleDatePicker
                    date={this.state.date} // momentPropTypes.momentObj or null
                    onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                    focused={this.state.focused} // PropTypes.bool
                    onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                    id="your_unique_id" // PropTypes.string.isRequired,
                    displayFormat="DD/MM/YYYY"
                  />
                </div>
                <div className="form-group">
                  <label>
                    {!this.state.hora_chegada ? (
                      <span className="text-danger">Horário da Chegada * </span>
                    ) : (
                      <React.Fragment>Horário da Chegada</React.Fragment>
                    )}
                  </label>
                  <MaskedInput
                    mask={[/[0-2]/, /\d/, ":", /[0-5]/, /\d/]}
                    className="form-control"
                    placeholder="digite o horário"
                    guide={false}
                    id="hora_chegada"
                    onBlur={() => {}}
                    //onChange={() => {}}
                    value={this.state.hora_chegada}
                    onChange={this.handleInputChangeHora.bind(this)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {!this.state.hora_saida ? (
                      <span className="text-danger">Horário de Saída * </span>
                    ) : (
                      <React.Fragment>Horário de Saída</React.Fragment>
                    )}
                  </label>
                  <MaskedInput
                    mask={[/[0-2]/, /\d/, ":", /[0-5]/, /\d/]}
                    className="form-control"
                    placeholder="digite o horário"
                    guide={false}
                    id="hora_saida"
                    onBlur={() => {}}
                    //onChange={() => {}}
                    value={this.state.hora_saida}
                    onChange={this.handleInputChangeHora.bind(this)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {!this.state.hora_liberacao ? (
                      <span className="text-danger">
                        Horário de Liberação *
                      </span>
                    ) : (
                      <React.Fragment>Horário de Liberação</React.Fragment>
                    )}
                  </label>
                  <MaskedInput
                    mask={[/[0-2]/, /\d/, ":", /[0-5]/, /\d/]}
                    className="form-control"
                    placeholder="digite o horário"
                    guide={false}
                    id="hora_liberacao"
                    onBlur={() => {}}
                    //onChange={() => {}}
                    value={this.state.hora_liberacao}
                    onChange={this.handleInputChangeHora.bind(this)}
                  />
                </div>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">Descrição Serviço</h5>
              <div className="card-body">
                <div className="form-group">
                  <label>Atividade</label>
                  <textarea
                    className="form-control"
                    id="atividade"
                    rows="2"
                    name="atividade"
                    onChange={this.handleInputChange.bind(this)}
                    value={this.state.atividade}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label>Descrição</label>
                  <textarea
                    className="form-control"
                    id="descricao"
                    rows="12"
                    name="descricao"
                    onChange={this.handleInputChange.bind(this)}
                    value={this.state.descricao}
                    readOnly
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="observacao">
                    {!this.state.observacao ? (
                      <span className="text-danger"> Observação * </span>
                    ) : (
                      <React.Fragment>Observação</React.Fragment>
                    )}
                  </label>
                  <textarea
                    onChange={this.handleInputChange.bind(this)}
                    className="form-control"
                    id="observacao"
                    name="observacao"
                    rows="3"
                    ref={textarea => {
                      this.observacao = textarea;
                    }}
                    value={this.state.observacao}
                  />
                </div>
              </div>
            </div>

            <div className="card marginTop6">
              <h5 className="card-header">Responsável </h5>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="tecnico">Nome do Técnico</label>
                  <input
                    type="text"
                    className="form-control"
                    id="tecnico"
                    name="tecnico"
                    //onChange={this.handleInputChange.bind(this)}
                    defaultValue={this.state.tecnico}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <center>
              {this.state.status === "concluido" && (
                <React.Fragment>
                  <center>
                    {this.state.status === "concluido" && (
                      <React.Fragment>
                        <center>
                          <div>
                            <div className="d-flex justify-content-center">
                              <div className="p-2 bd-highlight align-self-center">
                                <i
                                  className="fas fa-check-circle fa-2x"
                                  style={{ color: "green" }}
                                ></i>
                              </div>
                              <div className="p-2 bd-highlight align-self-center">
                                <b> Rat Concluída</b>
                              </div>
                            </div>
                          </div>
                        </center>
                      </React.Fragment>
                    )}
                  </center>
                </React.Fragment>
              )}
            </center>
            <div className="card marginTop6">
              <Submit
                load={this.state.load}
                submitClick={this.postForm}
                status={
                  this.state.status === "concluido" ||
                  this.state.status === "andamento"
                    ? false
                    : true
                }
              />
            </div>
            {this.state.status === "andamento" && (
              <React.Fragment>
                <div className="card marginTop6">
                  <button className="btn btn-danger" onClick={this.pauseTask}>
                    Pausar Tarefa
                  </button>
                </div>
              </React.Fragment>
            )}

            {(this.state.status === "pause" ||
              this.state.status === "pendente") && (
              <React.Fragment>
                <div className="card marginTop6">
                  <button className="btn btn-success" onClick={this.startTask}>
                    Inicar Tarefa
                  </button>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ActivityAll;
